<template>
  <h-container isTable title="项目列表">
    <template #extra-header>
      <div class="flex-1 text-align-right">
        <el-button type="primary" @click="addProject">添加项目</el-button>
      </div>
    </template>
    <el-table v-loading="uiModel.loading" :data="uiModel.list" stripe style="width: 100%">
      <el-table-column prop="id" label="编号" header-align="center" align="center" width="100" />
      <el-table-column prop="project_name" header-align="center" align="center" label="项目名称" width="180" />
      <el-table-column prop="project_desc" header-align="center" align="center" label="项目描述" min-width="230">
        <template #default="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.project_desc" placement="bottom-start">
            <div class="text-ellipsis">{{scope.row.project_desc}}</div>
          </el-tooltip>

        </template>
      </el-table-column>
      <el-table-column prop="createtime" header-align="center" align="center" label="创建时间" width="180">
        <template #default="scope">
          {{timeFormat(scope.row.createtime, "yyyy-mm-dd hh:MM:ss")}}
        </template>
      </el-table-column>
      <el-table-column prop="updatetime" header-align="center" align="center" label="修改时间" width="180">
        <template #default="scope">
          {{timeFormat(scope.row.updatetime, "yyyy-mm-dd hh:MM:ss")}}
        </template>
      </el-table-column>
      <el-table-column prop="status" header-align="center" align="center" label="状态">
        <template #default="scope">
          <el-tag v-if="scope.row.status == 'normal'" :type="scope.row.status == 'normal' ? 'success' : 'danger'"><h-dict mode="text" dictKey="status_type" v-model="scope.row.status"/></el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" align="center" header-align="center" fixed="right" width="260">
        <template #default="scope">
            <el-button type="primary" @click="openDialog(scope.row)"  link>查看</el-button>
            <el-button type="primary" @click="showQrCode(scope.row)"  link>查看二维码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <qr-dialog ref="qrDialogRef" :onVnodeBeforeMount="onVnodeBeforeMountRef_" />
    <project-dialog ref="projetDialogRef" :onVnodeBeforeMount="onVnodeBeforeMountRef_"  @on-load="load"/>
  </h-container>
</template>

<script lang="ts" setup>
  import {ProjectDialog, QrDialog} from "@/components/views/kh";
  import {ref, onMounted} from "vue";
  import {useTimeFormat} from "@hview/hview-vue3/packages";
  import {getProjectListApi} from "@/api/kh";
  const {timeFormat} = useTimeFormat();
  const uiModel = ref({
    loading: false,
    list: []
  });

  const qrDialogRef = ref();
  const projetDialogRef = ref();


  const showQrCode = (data: any) => {
    qrDialogRef.value.open(data);
  }


  /**
   * @description 加载数据
   */
  const load = () => {
    uiModel.value.loading = true;
    getProjectListApi().then((res: any) => {
      const data = res.data;
      uiModel.value.list = data;
    }).finally(() => {
      uiModel.value.loading = false;
    });
  }

  const openDialog = (data: any) => {
    projetDialogRef.value.open(data.id);
  }

  const addProject = () => {
    projetDialogRef.value.create();
  }


  onMounted(() => {
    load();
  });
</script>

<style scoped>

</style>